var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommitmentRate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9982 16.3845V19.4614C20.9982 19.8695 20.8361 20.2608 20.5476 20.5493C20.2591 20.8378 19.8678 20.9999 19.4597 20.9999H16.3828",
    stroke: "#4C466F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3828 1H19.4597C19.8678 1 20.2591 1.16209 20.5476 1.4506C20.8361 1.73912 20.9982 2.13044 20.9982 2.53846V5.61538",
    stroke: "#4C466F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.61538V2.53846C1 2.13044 1.16209 1.73912 1.4506 1.4506C1.73912 1.16209 2.13044 1 2.53846 1H5.61538",
    stroke: "#4C466F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.61538 20.9999H2.53846C2.13044 20.9999 1.73912 20.8378 1.4506 20.5493C1.16209 20.2608 1 19.8695 1 19.4614V16.3845",
    stroke: "#4C466F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9988 10.2308C12.6981 10.2308 14.0757 8.85317 14.0757 7.15383C14.0757 5.45449 12.6981 4.0769 10.9988 4.0769C9.29946 4.0769 7.92188 5.45449 7.92188 7.15383C7.92188 8.85317 9.29946 10.2308 10.9988 10.2308Z",
    stroke: "#4C466F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8598 16.3847C15.4223 15.466 14.7334 14.6901 13.873 14.1468C13.0126 13.6035 12.0158 13.3152 10.9983 13.3152C9.98068 13.3152 8.98393 13.6035 8.12351 14.1468C7.26309 14.6901 6.57422 15.466 6.13672 16.3847",
    stroke: "#4C466F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommitmentRate);
export default __webpack_public_path__ + "static/media/CommitmentRate.cafe7b2b3c550e6d5cc9a5bd5613e00c.svg";
export { ForwardRef as ReactComponent };